<template>
  <div class="stats-page">
    <!-- 顶部：Tab + 通用筛选 -->
    <el-card class="filter-card" shadow="never">
      <div class="fg-row">
        <div class="fg-item">
          <el-radio-group v-model="activeTab" size="small" @change="onTabChange">
            <el-radio-button label="perform">业绩统计</el-radio-button>
            <el-radio-button label="trend">入量趋势</el-radio-button>
            <el-radio-button label="promo">推广统计</el-radio-button>
          </el-radio-group>
        </div>
        <div class="fg-item">
          <span class="fg-label">统计区间</span>
          <el-date-picker
            v-model="range"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            style="width: 300px"
          />
        </div>
        <div v-if="isCompany" class="fg-item">
          <span class="fg-label">战队</span>
          <el-select v-model="filterUnitId" placeholder="全部战队" clearable size="small" style="width: 150px" @change="onUnitChange">
            <el-option v-for="u in units" :key="u.id" :label="u.name" :value="u.id" />
          </el-select>
        </div>
        <div v-if="isCompany" class="fg-item">
          <span class="fg-label">小组</span>
          <el-select v-model="filterTeamId" placeholder="全部小组" clearable size="small" style="width: 150px" @change="onTeamChange">
            <el-option v-for="t in teams" :key="t.id" :label="t.name" :value="t.id" />
          </el-select>
        </div>
        <div class="fg-item">
          <span class="fg-label">员工</span>
          <el-select v-model="filterStaffId" placeholder="全部员工" clearable size="small" style="width: 150px" @change="reload">
            <el-option v-for="s in staffOptions" :key="s.id" :label="s.name" :value="s.id" />
          </el-select>
        </div>
        <el-button type="primary" icon="el-icon-search" size="small" @click="reload">查询</el-button>
      </div>
      <!-- 业绩：维度切换 -->
      <div v-if="activeTab === 'perform'" class="fg-row second">
        <span class="fg-label">统计维度</span>
        <el-radio-group v-model="level" size="small" @change="reload">
          <el-radio-button label="staff">按员工</el-radio-button>
          <el-radio-button label="unit">按战队</el-radio-button>
          <el-radio-button label="team">按小组</el-radio-button>
        </el-radio-group>
      </div>
    </el-card>

    <!-- 业绩统计 -->
    <template v-if="activeTab === 'perform'">
      <el-card class="block-card" shadow="never">
        <div slot="header" class="block-head">
          <span class="block-title">业绩排行</span>
          <span class="block-sub">{{ rangeText }} · 核算 − 退款</span>
        </div>
        <div class="stat-summary">
          <div class="sum-item"><span class="sum-label">核算业绩</span><span class="sum-val">¥ {{ fmtMoney(performSummary.perform_amount) }}</span></div>
          <div class="sum-item refund"><span class="sum-label">退款冲减</span><span class="sum-val">¥ {{ fmtMoney(performSummary.refund_amount) }}</span></div>
          <div class="sum-item final"><span class="sum-label">最终业绩</span><span class="sum-val">¥ {{ fmtMoney(performSummary.final_amount) }}</span></div>
        </div>
        <el-table :data="performList" :header-cell-style="{ background: '#F7F9FC', color: '#18233C', fontWeight: 600 }" empty-text="暂无业绩数据" size="small">
          <el-table-column label="排名" width="80" align="center">
            <template slot-scope="{ $index }">
              <span class="rank-num" :class="'rank-' + ($index + 1)">{{ $index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="维度对象" min-width="160" />
          <el-table-column prop="bill_count" label="核算单数" width="100" align="center" />
          <el-table-column label="核算业绩" width="140" align="right">
            <template slot-scope="{ row }"><span class="money">¥ {{ fmtMoney(row.perform_amount) }}</span></template>
          </el-table-column>
          <el-table-column label="退款冲减" width="140" align="right">
            <template slot-scope="{ row }"><span class="money refund">¥ {{ fmtMoney(row.refund_amount) }}</span></template>
          </el-table-column>
          <el-table-column label="最终业绩" width="140" align="right">
            <template slot-scope="{ row }"><span class="money final">¥ {{ fmtMoney(row.final_amount) }}</span></template>
          </el-table-column>
        </el-table>
      </el-card>
    </template>

    <!-- 入量趋势 -->
    <template v-if="activeTab === 'trend'">
      <el-card class="block-card" shadow="never">
        <div slot="header" class="block-head">
          <span class="block-title">每日入量趋势</span>
          <span class="block-sub">{{ rangeText }} · 累计 {{ trendTotal }} 条</span>
        </div>
        <div ref="trendChart" class="chart-box"></div>
        <el-table :data="trendList" :header-cell-style="{ background: '#F7F9FC', color: '#18233C', fontWeight: 600 }" empty-text="当前范围暂无线索" size="small">
          <el-table-column prop="day" label="日期" min-width="120" />
          <el-table-column prop="total" label="录入量" width="120" align="center" />
          <el-table-column label="成交量" width="120" align="center">
            <template slot-scope="{ row }">{{ row.dealt }}</template>
          </el-table-column>
          <el-table-column label="成交率" min-width="120" align="center">
            <template slot-scope="{ row }">{{ row.total ? ((row.dealt / row.total) * 100).toFixed(1) + '%' : '—' }}</template>
          </el-table-column>
        </el-table>
      </el-card>
    </template>

    <!-- 推广统计 -->
    <template v-if="activeTab === 'promo'">
      <el-card class="block-card" shadow="never">
        <div slot="header" class="block-head">
          <span class="block-title">推广统计</span>
          <span class="block-sub">{{ rangeText }} · 录入 {{ promoTotal }} 条</span>
        </div>
        <el-table :data="promoList" :header-cell-style="{ background: '#F7F9FC', color: '#18233C', fontWeight: 600 }" empty-text="暂无推广数据" size="small">
          <el-table-column prop="staff_name" label="录入人" min-width="140" />
          <el-table-column prop="total" label="录入量" width="110" align="center" />
          <el-table-column prop="dealt" label="成交量" width="110" align="center" />
          <el-table-column label="成交率" width="120" align="center">
            <template slot-scope="{ row }"><span class="deal-rate">{{ row.deal_rate }}%</span></template>
          </el-table-column>
          <el-table-column prop="channel_count" label="渠道数" min-width="100" align="center" />
        </el-table>
      </el-card>
    </template>
  </div>
</template>

<script>
import { statsPerform, statsLeadTrend, statsPromo } from '@/api/stats'
import { unitList, teamList, staffList } from '@/api/org'
import { API_BASE } from '@/config'
import * as echarts from 'echarts'

export default {
  name: 'StatsIndex',
  data() {
    return {
      user: this.$store.state.user || {},
      // Tab 与区间
      activeTab: 'perform',
      range: null,
      pickerOptions: {
        disabledDate: d => d.getTime() > Date.now()
      },
      // 部门/员工筛选（仅公司可全局选；含推广/销售战队）
      filterUnitId: null,
      filterTeamId: null,
      filterStaffId: null,
      units: [],
      teams: [],
      staffOptions: [],
      // 业绩
      level: 'staff',
      performList: [],
      performSummary: {},
      // 入量
      trendList: [],
      trendTotal: 0,
      trendChart: null,
      // 推广
      promoList: [],
      promoTotal: 0
    }
  },
  computed: {
    isCompany() {
      return this.user.type === 'company'
    },
    rangeText() {
      if (!this.range || this.range.length !== 2) return '全部'
      return this.range[0] + ' ~ ' + this.range[1]
    }
  },
  created() {
    // 默认区间：最近一个月（含今天共 30 天）
    const now = new Date()
    const p = n => (n < 10 ? '0' + n : '' + n)
    const start = new Date(now.getTime() - 29 * 86400000)
    this.range = [
      start.getFullYear() + '-' + p(start.getMonth() + 1) + '-' + p(start.getDate()),
      now.getFullYear() + '-' + p(now.getMonth() + 1) + '-' + p(now.getDate())
    ]
    if (this.isCompany) this.loadUnits()
    else this.loadRoleStaff()
    this.reload()
  },
  mounted() {
    this.$nextTick(() => this.drawTrend())
  },
  methods: {
    onTabChange() {
      this.$nextTick(() => { if (this.activeTab === 'trend') this.drawTrend() })
      this.reload()
    },
    /* ---- 组织选项加载 ---- */
    loadUnits() {
      // 团队筛选含全部战队（推广 + 销售），便于按推广战队查看推广统计
      unitList()
        .then(d => {
          this.units = d.list || []
        })
        .catch(() => { this.units = [] })
    },
    onUnitChange() {
      this.filterTeamId = null
      this.filterStaffId = null
      if (!this.filterUnitId) {
        this.teams = []
        this.staffOptions = []
        this.reload()
        return
      }
      teamList({ unit_id: this.filterUnitId })
        .then(dt => {
          this.teams = dt.list || []
          return staffList({ unit_id: this.filterUnitId }).then(ds => ({ ds }))
        })
        .then(({ ds }) => { this.staffOptions = ds.list || [] })
        .catch(() => {})
        .finally(() => this.reload())
    },
    onTeamChange() {
      this.filterStaffId = null
      if (!this.filterTeamId) {
        this.staffOptions = []
        this.reload()
        return
      }
      staffList({ team_id: this.filterTeamId })
        .then(ds => { this.staffOptions = ds.list || [] })
        .catch(() => {})
        .finally(() => this.reload())
    },
    loadRoleStaff() {
      // 非公司角色：可选本部门员工（unit/team/staff 后端已限范围，员工下拉做当前范围展示）
      const u = this.user
      if (u.type === 'staff') {
        this.staffOptions = [{ id: u.id, name: u.name || '本人' }]
        this.filterStaffId = u.id
      } else if (u.type === 'unit' || u.type === 'team') {
        this.staffOptions = []
      }
    },
    /* ---- 数据加载 ---- */
    buildParams() {
      const p = {}
      if (this.range && this.range.length === 2) { p.start_date = this.range[0]; p.end_date = this.range[1] }
      if (this.isCompany) {
        if (this.activeTab === 'perform') {
          p.level = this.level
        }
        if (this.filterUnitId) p.unit_id = this.filterUnitId
        if (this.filterTeamId) p.team_id = this.filterTeamId
        if (this.filterStaffId) p.staff_id = this.filterStaffId
      } else {
        if (this.activeTab === 'perform') {
          p.level = this.level
        } else if (this.activeTab === 'promo' && this.filterStaffId) {
          p.staff_id = this.filterStaffId
        }
      }
      return p
    },
    reload() {
      this[this.activeTab + 'Load']()
    },
    performLoad() {
      statsPerform(this.buildParams())
        .then(d => {
          this.performList = (d && d.list) || []
          this.performSummary = ((d && d.summary) || {})
        })
        .catch(() => { this.performList = []; this.performSummary = {} })
    },
    trendLoad() {
      statsLeadTrend(this.buildParams())
        .then(d => {
          this.trendList = (d && d.list) || []
          this.trendTotal = (d && d.total) || 0
          this.$nextTick(() => this.drawTrend())
        })
        .catch(() => { this.trendList = []; this.trendTotal = 0 })
    },
    promoLoad() {
      statsPromo(this.buildParams())
        .then(d => {
          this.promoList = (d && d.list) || []
          this.promoTotal = (d && d.total) || 0
        })
        .catch(() => { this.promoList = []; this.promoTotal = 0 })
    },
    /* ---- 趋势图 ---- */
    drawTrend() {
      if (this.activeTab !== 'trend') return
      const el = this.$refs.trendChart
      if (!el) return
      if (!this.trendChart) this.trendChart = echarts.init(el)
      const days = this.trendList.map(r => r.day)
      const total = this.trendList.map(r => r.total)
      const dealt = this.trendList.map(r => r.dealt)
      this.trendChart.setOption({
        tooltip: { trigger: 'axis' },
        legend: { data: ['录入量', '成交量'], top: 0, right: 10 },
        grid: { left: 10, right: 12, top: 36, bottom: 10, containLabel: true },
        xAxis: { type: 'category', data: days, axisLabel: { fontSize: 10 } },
        yAxis: { type: 'value', minInterval: 1 },
        series: [
          { name: '录入量', type: 'line', smooth: true, data: total, symbol: 'none', lineStyle: { width: 2, color: '#3668FC' }, areaStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: 'rgba(54,104,252,0.18)' }, { offset: 1, color: 'rgba(54,104,252,0)' }] } } },
          { name: '成交量', type: 'line', smooth: true, data: dealt, symbol: 'none', lineStyle: { width: 2, color: '#2BB673' } }
        ]
      })
    },
    fmtMoney(n) {
      const v = parseFloat(n || 0)
      return v.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
  }
}
</script>

<style scoped>
.stats-page { padding: 0; }
.filter-card, .block-card { margin-bottom: 14px; border-radius: 10px; border: 1px solid #E5E9F2; }
.fg-row { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; }
.fg-row.second { margin-top: 12px; }
.fg-item { display: flex; align-items: center; gap: 6px; }
.fg-label { font-size: 13px; color: #5A6A85; white-space: nowrap; }
.block-head { display: flex; align-items: baseline; gap: 10px; }
.block-title { font-size: 14px; font-weight: 700; color: #18233C; }
.block-sub { font-size: 12px; color: #8A94AD; }

/* 汇总 */
.stat-summary { display: flex; gap: 16px; margin-bottom: 14px; flex-wrap: wrap; }
.sum-item {
  flex: 1; min-width: 160px; padding: 14px 18px; border-radius: 10px; background: #F5F8FF; border: 1px solid #E5E9F2;
}
.sum-item.refund { background: #FFF7F2; }
.sum-item.final { background: #F0F9F5; }
.sum-label { display: block; font-size: 12px; color: #8A94AD; margin-bottom: 6px; }
.sum-val { font-size: 20px; font-weight: 700; color: #3668FC; }
.sum-item.refund .sum-val { color: #ED6A2A; }
.sum-item.final .sum-val { color: #2BB673; }

/* 排名 */
.rank-num { display: inline-flex; width: 24px; height: 24px; align-items: center; justify-content: center; border-radius: 6px; background: #EEF1F8; color: #5A6A85; font-size: 12px; font-weight: 600; }
.rank-num.rank-1 { background: #3668FC; color: #fff; }
.rank-num.rank-2 { background: #5B8DFF; color: #fff; }
.rank-num.rank-3 { background: #9FBEFF; color: #fff; }
.money { font-weight: 600; color: #18233C; }
.money.refund { color: #ED6A2A; }
.money.final { color: #2BB673; }
.deal-rate { color: #2BB673; font-weight: 600; }

.chart-box { width: 100%; height: 320px; margin-bottom: 8px; }

/* 品牌色 */
::v-deep .el-button--primary { background: #3668FC; border-color: #3668FC; }
::v-deep .el-button--primary:hover, ::v-deep .el-button--primary:focus { background: #5B8DFF; border-color: #5B8DFF; }
::v-deep .el-table__row:hover > td { background: #F5F8FF !important; }
</style>